import React from 'react';
import PostHero from '../components/PostHero'
import PostFooter from '../components/PostFooter'
import PostContent from '../components/PostContent'
import PostOutcome from '../components/PostOutcome'
import PostContentList from '../components/PostContentList'
import PostCodeBlock from '../components/PostCodeBlock'

import banner from '../images/tune_upwards/tune_upwards_banner.jpg';
import intro from '../images/tune_upwards/tune_upwards1.jpg';
import post1 from '../images/tune_upwards/tune_upwards2.jpg';
import thumb from '../images/tune_upwards/tune_upwards3.jpg';
import techStack from '../images/tune_upwards/tune_upwards_techstack.jpg';


const PostTuneUpwards = () => {
    return (
        <div className="post_body">
        <div className="post_container">
            <PostHero 
            image={banner}
            title="Building Modern Music Explorer" 
                from="From" company="Personal Project"  role1="•  Buildng single page app uisng React.js + Vite" role2="• Fetching data from iTune API" role3="• Implementing sorting, search, and like features"  role4="• Managing global state without using a library" role5="• Styling page using CSS"
            />
            <PostCodeBlock classes="flex-row-reverse"  fullContainer={true} 
            text={`
                <h2>Project Objective</h2>
                <p className="mt-6">
                 After fetching the top albums (fewer than 100) from iTunes, I manage the album data globally using the Context API. The layout mimics browsing at a vinyl store, displaying only 10 albums at a time to ensure fast loading. Users can explore more albums seamlessly with infinite scroll.            " 
                </p>
            `}
            />
            <PostContent classes="" image={thumb} title="Fetching iTune API" 
            body="
            After fetching the top albums (fewer than 100) from iTunes, I manage the album data globally using the Context API. The layout mimics browsing at a vinyl store, displaying only 10 albums at a time to ensure fast loading. Users can explore more albums seamlessly with infinite scroll.
            "
            />
            <PostContent classes="flex-row-reverse" image={intro} title="Sort & Search" 
            body="
            After displaying the fetched data, I implemented sorting and search features. Users can sort albums by popularity, release date, or alphabetically. They can also search for a specific album or artist by name for quick access.
            "            
            />
            <PostContent classes="" image={post1} title="Favorites & Song Previews" 
            body="
            Finally, I added a like feature that allows users to favorite albums, with their selections saved in localStorage for persistence. On each album's detail page, users can also play previews of all songs included in the album for a more interactive experience.
            "
            />
           <PostOutcome image={techStack} classes="hidden" title="Learnings" 
            body="
                Through this project, I learned how the iTunes API works. It was a great exercise in building an app from start to finish without relying on third-party libraries or frameworks. Doing everything manually helped me understand the core concepts of API handling, state management, and optimizing performance. If I were to improve it, I’d explore adding features like caching and filtering.
            "
            button="Tune Upwards" url="https://tune-upwards-gules.vercel.app/"
            button2="Github" url2="https://github.com/jihyeonoh12/tune_upwards"
                />
            <PostFooter />
            </div>
        </div>
    )
}



export default PostTuneUpwards